import React, {CSSProperties} from 'react';

import './VerticalListItem.css';

interface VerticalListProps {
  children: React.ReactChild; // React.ReactNode
  className?: string;
  style?: CSSProperties;
}

const VerticalListItem: React.FC<VerticalListProps> = ({
  children,
  className,
  style,
}: VerticalListProps) => {
  return (
    <li className={`vertical-list ${className}`} style={style}>
      {children}
    </li>
  );
};

VerticalListItem.defaultProps = {
  className: '',
  style: undefined,
};

export default VerticalListItem;
